import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import type { TGetClientContactsRes } from 'api/swagger';
import { CLIENT_CONTACTS_GET_MANY } from '../query-keys';

export const useGetClientContacts = () => {
  return useQuery<TGetClientContactsRes[]>({
    queryKey: [CLIENT_CONTACTS_GET_MANY],
    queryFn: async () => {
      const { data } = await http.get<TGetClientContactsRes[]>('/client-office/v1/contacts');

      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 60 * 1000,
    cacheTime: 60 * 1000,
  });
};
